/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  ForgotPasswordRequestDTO,
  ForgotPasswordResponseDTO,
  ResendOtpParams,
  ResetPasswordDTO,
  VerifyOtpParams
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Verifies the OTP for password reset
 * @summary Verify OTP
 */
export const verifyOtp = (
    params: VerifyOtpParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<boolean>(
      {url: `/frontend/admin/forgot-password/verify-otp`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getVerifyOtpMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyOtp>>, TError,{params: VerifyOtpParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyOtp>>, TError,{params: VerifyOtpParams}, TContext> => {

const mutationKey = ['verifyOtp'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyOtp>>, {params: VerifyOtpParams}> = (props) => {
          const {params} = props ?? {};

          return  verifyOtp(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type VerifyOtpMutationResult = NonNullable<Awaited<ReturnType<typeof verifyOtp>>>
    
    export type VerifyOtpMutationError = unknown

    /**
 * @summary Verify OTP
 */
export const useVerifyOtp = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyOtp>>, TError,{params: VerifyOtpParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof verifyOtp>>,
        TError,
        {params: VerifyOtpParams},
        TContext
      > => {

      const mutationOptions = getVerifyOtpMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Resets the password with a new password
 * @summary Reset password
 */
export const resetPassword1 = (
    resetPasswordDTO: ResetPasswordDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<boolean>(
      {url: `/frontend/admin/forgot-password/reset`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: resetPasswordDTO, signal
    },
      options);
    }
  


export const getResetPassword1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPassword1>>, TError,{data: ResetPasswordDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof resetPassword1>>, TError,{data: ResetPasswordDTO}, TContext> => {

const mutationKey = ['resetPassword1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetPassword1>>, {data: ResetPasswordDTO}> = (props) => {
          const {data} = props ?? {};

          return  resetPassword1(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ResetPassword1MutationResult = NonNullable<Awaited<ReturnType<typeof resetPassword1>>>
    export type ResetPassword1MutationBody = ResetPasswordDTO
    export type ResetPassword1MutationError = unknown

    /**
 * @summary Reset password
 */
export const useResetPassword1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPassword1>>, TError,{data: ResetPasswordDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetPassword1>>,
        TError,
        {data: ResetPasswordDTO},
        TContext
      > => {

      const mutationOptions = getResetPassword1MutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Resends OTP for password reset with rate limiting
 * @summary Resend OTP
 */
export const resendOtp = (
    params: ResendOtpParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ForgotPasswordResponseDTO>(
      {url: `/frontend/admin/forgot-password/resend-otp`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getResendOtpMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendOtp>>, TError,{params: ResendOtpParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof resendOtp>>, TError,{params: ResendOtpParams}, TContext> => {

const mutationKey = ['resendOtp'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resendOtp>>, {params: ResendOtpParams}> = (props) => {
          const {params} = props ?? {};

          return  resendOtp(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ResendOtpMutationResult = NonNullable<Awaited<ReturnType<typeof resendOtp>>>
    
    export type ResendOtpMutationError = unknown

    /**
 * @summary Resend OTP
 */
export const useResendOtp = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendOtp>>, TError,{params: ResendOtpParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resendOtp>>,
        TError,
        {params: ResendOtpParams},
        TContext
      > => {

      const mutationOptions = getResendOtpMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Initiates the password reset process
 * @summary Initiate password reset
 */
export const initiatePasswordReset = (
    forgotPasswordRequestDTO: ForgotPasswordRequestDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ForgotPasswordResponseDTO>(
      {url: `/frontend/admin/forgot-password/initiate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: forgotPasswordRequestDTO, signal
    },
      options);
    }
  


export const getInitiatePasswordResetMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initiatePasswordReset>>, TError,{data: ForgotPasswordRequestDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof initiatePasswordReset>>, TError,{data: ForgotPasswordRequestDTO}, TContext> => {

const mutationKey = ['initiatePasswordReset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof initiatePasswordReset>>, {data: ForgotPasswordRequestDTO}> = (props) => {
          const {data} = props ?? {};

          return  initiatePasswordReset(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InitiatePasswordResetMutationResult = NonNullable<Awaited<ReturnType<typeof initiatePasswordReset>>>
    export type InitiatePasswordResetMutationBody = ForgotPasswordRequestDTO
    export type InitiatePasswordResetMutationError = unknown

    /**
 * @summary Initiate password reset
 */
export const useInitiatePasswordReset = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initiatePasswordReset>>, TError,{data: ForgotPasswordRequestDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof initiatePasswordReset>>,
        TError,
        {data: ForgotPasswordRequestDTO},
        TContext
      > => {

      const mutationOptions = getInitiatePasswordResetMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    